/**
 * The Meta (Facebook) Pixel id: build-time `VITE_META_PIXEL_ID` (public, it ends up in the browser). Unset or not a pixel id = the pixel is off
 * completely: no script, no cookie, no request. Only the production build sets it (Dockerfile.production); staging and the app never do.
 */

/** A pixel id is digits only (Meta's are 15-16 digits today); anything else is treated as unset rather than sent to Meta. */
const PIXEL_ID = /^\d{5,20}$/;

export function parseMetaPixelId(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const id = raw.trim();
  return PIXEL_ID.test(id) ? id : null;
}

/** Read at call time (not module load), so a test can stub the build variable. Vite still inlines the value at build time. */
export const metaPixelId = (): string | null => parseMetaPixelId(import.meta.env.VITE_META_PIXEL_ID);
